import React from 'react';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import { Avatar } from 'eymp-uicomps';
import LabelValue from 'eymp-uicomps/components/LabelValue';
import Divider from '@mui/material/Divider';
import Spinner from 'src/ui/library/Spinner/Spinner';
import _ from 'lodash';
import DOMPurify from 'dompurify';
import unescape from 'lodash.unescape';
import { MESSAGING_URL } from 'src/constants/constants';
import intl from 'react-intl-universal';
import { fnInsertStoragekey } from 'src/helpers/commonFunctions';
import { MESSAGE_NAV_KEY, MESSAGE_NAV_CASE_NUMBER } from 'src/constants/constants';

class MessagesPres extends React.Component {
  componentDidMount() {}
  componentWillUnmount() {}
  horizontaFlatLine = {
    marginLeft: '0px !important',
    marginRight: '0px  !important',
  };
  fnSplitName(item, index) {
    return _.nth(_.split(_.first(item.from).name, ' '), index);
  }

  handleOnClick() {
    fnInsertStoragekey(MESSAGE_NAV_KEY, this.props.caseId);
    sessionStorage.setItem(MESSAGE_NAV_CASE_NUMBER, this.props.caseNumber);
    window.location.href = DOMPurify.sanitize(`${MESSAGING_URL}/${this.props.caseId}`);
  }

  getPageContent(messagesResponse) {
    if (!messagesResponse) {
      return (
        <div style={{ margin: 'auto' }}>
          <Spinner size={30} />
        </div>
      );
    }
    if (messagesResponse && messagesResponse.messages && messagesResponse.messages.length === 0) {
      return intl.get('newDashboard.common.noItemtoDisplay');
    }

    return _.map(messagesResponse.messages, (item, index) => (
      <React.Fragment>
        <div className="d-flex flex-margin">
          <div className="message-avatar-wrapper">
            <Avatar firstName={this.fnSplitName(item, 0)} lastName={this.fnSplitName(item, 1)} color={index > 0 ? 'orange' : 'Green'} />
          </div>
          <div className="font-light case-text-line-height">
            <div className="msg-label">{_.first(item.from).name}</div>
            <div className="font-12">{item.ticketNumber}</div>
          </div>
        </div>
        <Grid className="update-label" item md={12}>
          {item.subject ? (item.subject.length > 45 ? _.join(_.take(item.subject, 45), '') + '...' : item.subject) : ''}
        </Grid>
        <Grid className="update-content" item md={12}>
          <span dangerouslySetInnerHTML={{ __html: this.getHTMLContent(item, 165) }}></span>
        </Grid>
        <div
          style={{
            width: '100%',
            padding: '14px 0px 14px 0px',
          }}>
          <Divider sx={this.horizontaFlatLine} textAlign="center" variant="middle" />
        </div>
      </React.Fragment>
    ));
  }
  getHTMLContent(item, length) {
    item.preview = item.preview ? unescape(item.preview).replace(/<(?:.|\n)*?>/gm, '') : '';
    let value = item.preview ? (item.preview.length > length ? _.join(_.take(item.preview, length), '') + '...' : item.preview) : '';
    return DOMPurify.sanitize(value);
  }
  render() {
    let { data: messagesResponse } = this.props;
    return (
      <Grid item sm={12}>
        <Grid className="header-wrap">
          <LabelValue value={'MESSAGES (' + (messagesResponse ? messagesResponse.totalMessagesCount : 0) + ')'} />
        </Grid>

        <Grid className="message-wrapper" container>
          <div className="cursor-pointer w-100" onClick={e => this.handleOnClick()}>
            {this.getPageContent(messagesResponse)}
          </div>
          {messagesResponse && messagesResponse.messages && messagesResponse.messages.length > 0 && (
            <div className="see-msg-btn">
              <button className="see-all-msg cursor-pointer" onClick={e => this.handleOnClick()}>
                See all messages
              </button>
            </div>
          )}
        </Grid>
      </Grid>
    );
  }
}
const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(MessagesPres);
